export default __webpack_public_path__ + "static/media/solana.dadd6d15.png";